var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4545 4.81818H13.0545V4.56965L12.8788 4.39392L12.4545 4.81818ZM8.63636 1L9.06063 0.575736L8.88489 0.4H8.63636V1ZM8.63631 4.81818L8.03631 4.81817L8.03631 5.41818H8.63631V4.81818ZM4.81821 8.03637H4.21821V9.23637H4.81821V8.03637ZM8.63639 9.23637H9.23639V8.03637H8.63639V9.23637ZM4.81821 10.5818H4.21821V11.7818H4.81821V10.5818ZM7.36367 11.7818H7.96367V10.5818H7.36367V11.7818ZM12.8788 4.39392L9.06063 0.575736L8.2121 1.42426L12.0303 5.24245L12.8788 4.39392ZM8.63636 0.4H2.27273V1.6H8.63636V0.4ZM2.27273 0.4C1.24036 0.4 0.4 1.24036 0.4 2.27273H1.6C1.6 1.9031 1.9031 1.6 2.27273 1.6V0.4ZM0.4 2.27273V13.7273H1.6V2.27273H0.4ZM0.4 13.7273C0.4 14.7596 1.24036 15.6 2.27273 15.6V14.4C1.9031 14.4 1.6 14.0969 1.6 13.7273H0.4ZM2.27273 15.6H11.1818V14.4H2.27273V15.6ZM11.1818 15.6C12.2142 15.6 13.0545 14.7596 13.0545 13.7273H11.8545C11.8545 14.0969 11.5514 14.4 11.1818 14.4V15.6ZM13.0545 13.7273V4.81818H11.8545V13.7273H13.0545ZM8.03636 0.999992L8.03631 4.81817L9.23631 4.81819L9.23636 1.00001L8.03636 0.999992ZM8.63631 5.41818H12.4545V4.21818H8.63631V5.41818ZM4.81821 9.23637H8.63639V8.03637H4.81821V9.23637ZM4.81821 11.7818H7.36367V10.5818H4.81821V11.7818Z",
    fill: "#627790"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.029872b5bf0e98a1f98d836417ad62f5.svg";
export { ForwardRef as ReactComponent };